import styles from './AiTestPage.module.css';

import React, { useEffect, useState, useCallback, useMemo } from 'react';

import { ScrollableContent, Smol, Button, Spinner, Flex, TabsHeader, Hr, Icon, NestedPropertySelect, CheckboxGroup } from 'ui-components';

import { asyncSocketAckEmit, getSubmissionsPropsSelectData } from 'helpers';

const CHART_TYPE_OPTIONS = [
  {
    value: 'line',
    label: 'Line graph',
    icon: <Icon id="chart-line" />
  },
  {
    value: 'pie',
    label: 'Pie chart',
    icon: <Icon id="chart-pie" />
  }
];

/* -------------------------------------------------------------------------- */
/*                         REQUESTS TESTING COMPONENT                         */
/* -------------------------------------------------------------------------- */

const RequestTesting = React.memo(() => {
  /* --------------------------- TESTING IO REQUESTS -------------------------- */

  // Request
  const lastIoEvent = 'getSubmissionsChartsData';

  const lastIoRequest = useMemo(() => {
    return {
      form: '614adf7325cc77017da84741'
    };
  }, []);

  // Response
  const [lastIoResponse, setLastIoResponse] = useState(null);
  const [isIoLoading, setIsIoLoading] = useState(false);

  // Reducer
  const request = useCallback(async () => {
    setIsIoLoading(true);
    const response = await asyncSocketAckEmit(lastIoEvent, lastIoRequest);
    setIsIoLoading(false);

    setLastIoResponse(response);
  }, [lastIoRequest]);

  /* ----------------------------------- JSX ---------------------------------- */

  return (
    <>
      <TabsHeader>IO.SOCKET REQUEST TESTING</TabsHeader>

      <Flex>
        <Button theme="black" onClick={() => request()}>
          Send io.socket event - {lastIoEvent}
        </Button>
      </Flex>
      <Smol.Collapse label="Last io.socket request" defaultShow={true}>
        <pre className={styles.json}>{JSON.stringify(lastIoRequest, 0, 2)}</pre>
      </Smol.Collapse>
      <Smol.Collapse label="Last IO response" defaultShow={true}>
        <pre className={styles.json}>{isIoLoading ? <Spinner /> : JSON.stringify(lastIoResponse, 0, 2)}</pre>
      </Smol.Collapse>
    </>
  );
});

/* -------------------------------------------------------------------------- */
/*                            UI TESTING COMPONENT                            */
/* -------------------------------------------------------------------------- */

const UiTesting = React.memo(() => {
  /* ----------------------------------- JSX ---------------------------------- */

  const [value, setValue] = useState(new Set());

  return (
    <>
      <TabsHeader>UI TESTING</TabsHeader>
      <CheckboxGroup theme="default" label="Default layout" data={CHART_TYPE_OPTIONS} value={value} onChange={setValue} />
      <CheckboxGroup theme="blocks-compact" label="Blocks compact layout" data={CHART_TYPE_OPTIONS} value={value} onChange={setValue} />
      <CheckboxGroup theme="blocks" label="Blocks layout" data={CHART_TYPE_OPTIONS} value={value} onChange={setValue} />
    </>
  );
});

/* -------------------------------------------------------------------------- */
/*                               MAIN COMPONENT                               */
/* -------------------------------------------------------------------------- */

const TestPage = React.memo(() => {
  return (
    <ScrollableContent className={styles.root}>
      <Hr />
      <UiTesting />
      <Hr />
      <RequestTesting />
      <Hr />
    </ScrollableContent>
  );
});

export default TestPage;
